import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledComposePatientSearchContainer = styled(Ds.Flex).attrs({
    flexDirection: "column",
    gap: "2",
})`
    height: 100%;
`;
